import {ChangePasswordUser, ProfileUserData,} from "../models/adminUsers.model";
import { useEffect, useState } from "react";
import { changePasswordService } from "../services/adminUser.service";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { ToastControlBackendModel } from "../../../../../components/Sidebar/ToastBackControl/models/toastBackControl.model";

interface Props {
  getAllUsersData: () => void;
  setDialogChangePasswordUser: (data: boolean) => void;
  dataUser: ProfileUserData;
  setMessageBackend: (value: ToastControlBackendModel) => void;
}

function FormChangePassword({
  getAllUsersData,
  setDialogChangePasswordUser,
  dataUser,
  setMessageBackend,
}: Props): JSX.Element {
  const [password, setPassword] = useState<string>("");
  const [passwordConfirm, setConfirmPassword] = useState<string>("");
  const [validatePassword, setValidatePassword] = useState<boolean>(true);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidatePassword(true);
    try {
      const data: ChangePasswordUser = {
        idUser: dataUser.idUser,
        password,
      };
      const response = await changePasswordService(data);
      if (response) {
        getAllUsersData();
        setDialogChangePasswordUser(false);
        setMessageBackend({
          detailValue: "Contraseña cambiada con éxito",
          severityValue: "success",
          lifeValue: 3000,
          validateShowMessage: true,
        });
      }
    } catch (error) {
      setMessageBackend({
        detailValue: "Ocurrió un error al cambiar la contraseña",
        severityValue: "error",
        lifeValue: 3000,
        validateShowMessage: true,
      });
    } finally {
      setValidatePassword(false);
    }
  };

  useEffect(() => {
    if (password && passwordConfirm) {
      if (password === passwordConfirm) {
        setValidatePassword(false);
      } else {
        setValidatePassword(true);
      }
    } else {
      setValidatePassword(true);
    }
  }, [password, passwordConfirm]);

  const inputStyle: React.CSSProperties = {
    backgroundColor: "#ffffff",
    color: "#333333",
    border: "1px solid #cbd5e1",
    width: "100%",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
  };

  return (
    <div className="w-full px-2 py-2">
      {/* Forzamos que los marcadores de posición (placeholders) tengan un color gris visible */}
      <style>{`
        .p-password input::placeholder {
          color: #64748b !important;
          opacity: 1 !important;
        }
        /* Ajuste para que el icono nativo de PrimeReact no se monte sobre el texto */
        .p-input-icon-left > input {
          padding-left: 2.5rem !important;
        }
        .p-input-icon-left > i {
          color: #64748b !important;
        }
      `}</style>

      <form className="flex flex-column gap-4 w-full" onSubmit={onSubmit}>

        {/* Input: Nueva Contraseña */}
        <div className="w-full">
          <span className="p-input-icon-left w-full">
            <i className="pi pi-lock" />
            <Password
              autoFocus
              className="w-full"
              inputClassName="w-full"
              style={{ width: "100%" }}
              inputStyle={inputStyle}
              placeholder="Nueva contraseña"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setPassword(e.target.value)
              }
              feedback={false}
              id="password"
              toggleMask
            />
          </span>
        </div>

        {/* Input: Confirmar Contraseña */}
        <div className="w-full">
          <span className="p-input-icon-left w-full">
            <i className="pi pi-lock" />
            <Password
              className="w-full"
              inputClassName="w-full"
              style={{ width: "100%" }}
              inputStyle={inputStyle}
              placeholder="Confirmar contraseña"
              value={passwordConfirm}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setConfirmPassword(e.target.value)
              }
              feedback={false}
              id="passwordConfirm"
              toggleMask
            />
          </span>
          {password.length > 0 && passwordConfirm.length > 0 && validatePassword && (
            <span
              className="text-sm mt-2 text-right block font-medium"
              style={{ color: "#ef4444" }}
            >
              Las contraseñas no coinciden
            </span>
          )}
        </div>

        {/* Botón Cambiar */}
        <div className="w-full mt-1">
          <Button
            type="submit"
            label="Cambiar"
            className="w-full text-white font-semibold py-3 border-round"
            style={{
              backgroundColor: "#00A86B",
              borderColor: "#00A86B",
              fontSize: "1.1rem",
            }}
            disabled={validatePassword}
          />
        </div>
      </form>
    </div>
  );
}

export default FormChangePassword;